/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { TableBody, TableRow } from '@material-ui/core';
import _ from 'lodash';
import { CELL_TYPES } from '../foTableBuilder/FOCellTypes';
import useStyles from './FOTableBodyStyle';
import FOBodyCheckboxCell from './BodyCells/FOBodyCheckboxCell';
import FOBodyCombinedCell from './BodyCells/FOBodyCombinedCell';
import FOBodyActionCell from './BodyCells/FOBodyActionCell';
import FOBodyCell from './BodyCells/FOBodyCell';
import EmptyCell from './BodyCells/FOBodyEmptyCell';
import useTableBody from './useTableBody';
import { getSubmissionErrors } from '../../../shared/submission/submissionPropertyAccessor';

export default function FOTableBody({
  rows,
  data,
  isRowSelected,
  handleSelectRow,
  handleActionMenuClick,
  getActionsTooltipText,
  filter,
  setFilter,
  emptyTableData,
  emptyTableSuggestion,
  selectedRow,
  anchorActionMenu,
  computeActionEntries,
  computeCombinedCellEntries,
  tableConfiguration,
  emptyTableWarningMessage,
  error,
}) {
  const classes = useStyles();
  const anyAppliedFilters = filter?.length;
  const { getTableBodyCellData } = useTableBody(data, tableConfiguration?.columns);

  return (
    <TableBody>
      {rows?.length ? (
        rows.map((rowData, itemIndex) => {
          const itemHasError = getSubmissionErrors(data?.filter(d => d.id === rowData.id))?.length > 0;
          const tableCells = _.sortBy(getTableBodyCellData(rowData), c => c.order);

          return (
            <TableRow hover key={rowData.id} className={itemHasError ? classes.errorRow : null}>
              {tableCells?.map((cellData, index) => {
                switch (cellData?.type) {
                  case CELL_TYPES.SELECT_ALL:
                    return (
                      <FOBodyCheckboxCell
                        key={index}
                        cellData={cellData}
                        isRowSelected={isRowSelected}
                        item={rowData}
                        handleSelectRow={handleSelectRow}
                      />
                    );
                  case CELL_TYPES.ROLES:
                  case CELL_TYPES.STATUS:
                    return (
                      <FOBodyCell
                        key={index}
                        itemTableCell={cellData}
                        itemCellIndex={index}
                        itemIndex={itemIndex}
                        hasChips={true}
                      />
                    );
                  case CELL_TYPES.INVITATION_STATUS:
                  case CELL_TYPES.DEFAULT:
                    return (
                      <FOBodyCell key={index} itemTableCell={cellData} itemCellIndex={index} itemIndex={itemIndex} />
                    );
                  case CELL_TYPES.COMBINED:
                    return (
                      <FOBodyCombinedCell
                        computeCombinedCellEntries={computeCombinedCellEntries}
                        key={index}
                        cellData={cellData}
                        item={rowData}
                      />
                    );
                  case CELL_TYPES.ACTION:
                    return (
                      <FOBodyActionCell
                        selectedRow={selectedRow}
                        anchorActionMenu={anchorActionMenu}
                        key={index}
                        getActionsTooltipText={getActionsTooltipText}
                        handleActionMenuClick={handleActionMenuClick}
                        data={rowData}
                        cellData={cellData}
                        computeActionEntries={computeActionEntries}
                      />
                    );
                  default:
                    return null;
                }
              })}
            </TableRow>
          );
        })
      ) : (
        <EmptyCell
          warningMessage={emptyTableWarningMessage}
          suggestion={emptyTableSuggestion}
          config={tableConfiguration?.table}
          emptyTableData={emptyTableData}
          anyAppliedFilters={anyAppliedFilters}
          setFilter={setFilter}
          error={error}
        />
      )}
    </TableBody>
  );
}
